var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFriendemoji3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 89,
    viewBox: "0 0 89 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.3498 55.322C58.9349 55.322 65.3369 53.1147 65.3967 59.2318C58.8538 59.7846 26.3367 60.5188 23.0528 58.5992C22.8124 53.9427 27.5548 55.2886 31.9964 55.3172C36.112 55.3433 40.2339 55.322 44.3498 55.322ZM33.736 36.8347C27.1409 40.9484 21.5655 35.5002 25.0567 30.355C27.6986 26.4611 36.0822 26.6399 33.736 36.8347ZM57.5137 28.5247C64.3418 25.7833 67.2053 36.4223 60.8251 38.2952C54.5849 40.1266 50.7924 31.223 57.5137 28.5247ZM87.9494 50.3696C91.84 24.4284 72.7084 3.76973 50.9585 0.519028C24.7717 -3.39568 3.86285 15.4448 0.547746 37.3645C-3.49305 64.0814 15.4163 84.5855 37.7243 87.9165C64.2918 91.8838 84.6156 72.5958 87.9494 50.3696Z",
    fill: "#F2B51E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFriendemoji3);
export default __webpack_public_path__ + "static/media/friendemoji3.b673676724b7d25d3983e8d5ea619cc9.svg";
export { ForwardRef as ReactComponent };